import { lazy } from "react";

export default (callback) =>
  lazy(() => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(callback()), 500);
    });
  });
